import { ATTRS, TAGS } from '../constants';
import { Entity } from '../types';
import { decodeDDI, encodeDDI } from '../utils';

export class DataLogTriggerEntity implements Entity {
  public static fromXML(xml) {
    const attrs = xml._attributes;

    return {
      entity: new DataLogTriggerEntity(
        decodeDDI(attrs[ATTRS.DataLogTrigger.DataLogDDI]),
        attrs[ATTRS.DataLogTrigger.DataLogMethod],
        attrs[ATTRS.DataLogTrigger.DataLogPGN],
        attrs[ATTRS.DataLogTrigger.DataLogPGNStartBit],
        attrs[ATTRS.DataLogTrigger.DataLogPGNStopBit]
      ),
    };
  }
  public type = TAGS.DataLogTrigger;

  constructor(
    public DDI: number,
    public method: number,
    public dataLogPGN?: number,
    public dataLogPGNStartBit?: number,
    public dataLogPGNStopBit?: number
  ) {}

  public toXML() {
    return {
      _attributes: {
        [ATTRS.DataLogTrigger.DataLogDDI]: encodeDDI(this.DDI),
        [ATTRS.DataLogTrigger.DataLogMethod]: this.method,
        [ATTRS.DataLogTrigger.DataLogPGN]: this.dataLogPGN,
        [ATTRS.DataLogTrigger.DataLogPGNStartBit]: this.dataLogPGNStartBit,
        [ATTRS.DataLogTrigger.DataLogPGNStopBit]: this.dataLogPGNStopBit,
      },
    };
  }
}
